import { useDashboardGlobalContext } from '@/dashboards/providers/dashboardGlobalContext';
import { calculateCampaignDateConstraints } from '@/utils/campaignDateConstraints';
import { addDays, startOfDay } from 'date-fns';
import moment from 'moment';
import { useMemo } from 'react';

export const useCampaignFormDefaults = () => {
    const {
        dashboard: {
            modelStartDate: rawModelStartDate,
            modelEndDate: rawModelEndDate,
            campaignMinStartDate,
            campaignMaxEndDate,
            campaignDefaultStartDate,
            campaignDefaultEndDate,
        },
    } = useDashboardGlobalContext();

    const modelStartDate = rawModelStartDate
        ? moment(rawModelStartDate).format('DD-MM-YYYY')
        : '';
    const modelEndDate = rawModelEndDate
        ? moment(rawModelEndDate).format('DD-MM-YYYY')
        : '';

    const dateConstraints = useMemo(
        () =>
            calculateCampaignDateConstraints(
                modelStartDate,
                modelEndDate,
                campaignMinStartDate,
                campaignMaxEndDate,
            ),
        [modelStartDate, modelEndDate, campaignMinStartDate, campaignMaxEndDate],
    );

    const defaultStartDate = useMemo(() => {
        if (campaignDefaultStartDate) {
            const parsedDate = new Date(campaignDefaultStartDate);
            if (parsedDate <= dateConstraints.selectableMaxDate) {
                return startOfDay(parsedDate);
            }
        }

        if (dateConstraints.selectableMinDate > new Date()) {
            return startOfDay(dateConstraints.selectableMinDate);
        }

        return startOfDay(new Date());
    }, [dateConstraints.selectableMinDate, dateConstraints.selectableMaxDate, campaignDefaultStartDate]);

    const defaultEndDate = useMemo(() => {
        if (campaignDefaultEndDate) {
            const parsedDate = new Date(campaignDefaultEndDate);
            if (parsedDate >= dateConstraints.selectableMinDate) {
                return startOfDay(parsedDate);
            }
        }

        return addDays(defaultStartDate, 10);
    }, [defaultStartDate, dateConstraints.selectableMinDate, campaignDefaultEndDate]);

    return { defaultStartDate, defaultEndDate, dateConstraints };
};
